import { t } from "i18next";

import type { ActivityMessage, TicketDetail } from "~/stores/tickets-store";

type Actor = ActivityMessage["actor"];
export type Contact = TicketDetail["contact"];

export const getActorAvatar = (actor: Actor) => {
  return actor.__typename === "SupportActorAppContact"
    ? ""
    : actor.__typename === "SupportActorEmailContact"
      ? ""
      : actor.__typename === "ActorInternalUser" ||
          actor.__typename === "SupportActorInternalUser"
        ? actor.internalUser.picture
        : actor.__typename === "ActorBotUser" ||
            actor.__typename === "SupportActorBotUser"
          ? `https://api.dicebear.com/9.x/bottts/svg?seed=${actor.id}`
          : actor.supplierUser.picture;
};
export const getActorInitials = (actor: Actor) => {
  return actor.__typename === "SupportActorAppContact"
    ? (actor.appContact.firstName?.[0] ?? "") +
        (actor.appContact.lastName?.[0] ?? "")
    : actor.__typename === "SupportActorEmailContact"
      ? (actor.emailContact.name?.[0] ?? actor.emailContact.email[0] ?? "")
      : actor.__typename === "ActorInternalUser" ||
          actor.__typename === "SupportActorInternalUser"
        ? (actor.internalUser.firstName[0] ?? "") +
          (actor.internalUser.lastName[0] ?? "")
        : actor.__typename === "ActorBotUser" ||
            actor.__typename === "SupportActorBotUser"
          ? (actor.botUser.name[0] ?? "")
          : (actor.supplierUser.firstName[0] ?? "") +
            (actor.supplierUser.lastName[0] ?? "");
};
export const getActorFullName = (actor: Actor) => {
  return actor.__typename === "SupportActorAppContact"
    ? actor.appContact.firstName || actor.appContact.lastName
      ? `${actor.appContact.firstName} ${actor.appContact.lastName}`
      : t("contact.unknown")
    : actor.__typename === "SupportActorEmailContact"
      ? actor.emailContact.name && actor.emailContact.name.trim().length > 0
        ? actor.emailContact.name
        : t("contact.unknown")
      : actor.__typename === "ActorInternalUser" ||
          actor.__typename === "SupportActorInternalUser"
        ? `${actor.internalUser.firstName} ${actor.internalUser.lastName}`
        : actor.__typename === "ActorBotUser" ||
            actor.__typename === "SupportActorBotUser"
          ? actor.botUser.name
          : `${actor.supplierUser.firstName} ${actor.supplierUser.lastName}`;
};
export const getContactFullName = (
  contact:
    | {
        __typename: "SupportActorAppContact";
        appContact: {
          firstName?: string | null | undefined;
          lastName?: string | null | undefined;
        };
      }
    | {
        __typename: "SupportActorEmailContact";
        emailContact: {
          email: string | null | undefined;
          name?: string | null | undefined;
        };
      },
) => {
  return contact.__typename === "SupportActorAppContact"
    ? contact.appContact.firstName || contact.appContact.lastName
      ? `${contact.appContact.firstName} ${contact.appContact.lastName}`
      : t("contact.unknown")
    : contact.emailContact.name && contact.emailContact.name.trim().length > 0
      ? contact.emailContact.name
      : t("contact.unknown");
};
